module.exports = __webpack_public_path__ + "img/CTWP__Sword_04.1c4d0b8c.png";